import React from "react";
import LegalPage from "./LegalPage";

const Terms = () => <LegalPage type="terms" />;

export default Terms;
